// import React from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import "../../Styles/SportsSlider.css";
// import {
//   allProductDetails,
//   homefilterApi,
// } from "../../Services/Operations/ProductAPI";
// import { useNavigate } from "react-router-dom";

// function TakeClub() {
//   const sports = [
//     {
//       name: "RUNNING",
//       image1: "/asset/img/Ecom/1 (2).webp",
//       image2: "/asset/img/Ecom/4 (2).webp",
//     },
//     {
//       name: "FITNESS",
//       image1: "/asset/img/Ecom/2 (2).webp",
//       image2: "/asset/img/Ecom/3 (2).webp",
//     },
//     {
//       name: "FOOTBALL",
//       image1: "/asset/img/Ecom/25.webp",
//       image2: "/asset/img/Ecom/20.webp",
//     },
//     {
//       name: "BADMINTON",
//       image1: "/asset/img/Ecom/Banner men-01.webp",
//       image2: "/asset/img/Ecom/14 (3).webp",
//     },
//     {
//       name: "CYCLING",
//       image1: "/asset/img/Ecom/30.webp",
//       image2: "/asset/img/Ecom/30.webp",
//     },
//     {
//       name: "CRICKET",
//       image1: "/asset/img/Ecom/35.webp",
//       image2: "/asset/img/Ecom/34.webp",
//     },
//     {
//       name: "BASKETBALL",
//       image1: "/asset/img/Ecom/26.webp",
//       image2: "/asset/img/Ecom/28.webp",
//     },
//   ];
//   const settings = {
//     dots: false,
//     infinite: true,
//     adaptiveHeight: true,
//     speed: 500,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     arrows: true,
//     responsive: [
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 3,
//         },
//       },
//       {
//         breakpoint: 450,
//         settings: {
//           slidesToShow: 2,
//         },
//       },
//     ],
//   };
//   const navigate = useNavigate();

//   const handleSportClick = async (categoryName) => {
//     try {
//       console.log("categoryName : ", categoryName);
//       const products = await homefilterApi(categoryName);
//       console.log("Products for:", categoryName, products);

//       navigate("/AllListingPage", {
//         state: {
//           products: products.data,
//         },
//       });
//     } catch (error) {
//       console.error("Error fetching products:", error);
//     }
//   };

//   return (
//     <div>
//       <div
//         className="cms-section no-overflow pos-3 cms-section-default"
//         style={{ backgroundColor: "white" }}
//       >
//         <div className="cms-section-default full-width">
//           <div className="cms-block block-container-2 title-text-box pos-0 cms-block-text">
//             <div className="cms-block-container">
//               <div className="cms-block-container-row row cms-row">
//                 <div
//                   className="col-12"
//                   data-cms-element-id="2eb0409c0b874fceacad996d8f8bf32a"
//                 >
//                   <div className="cms-element-text">
//                     <div className="text-box-emotion">
//                       <h3 className="t1 large1">
//                         Level Up Your Team
//                         <span style={{ fontFamily: "Arial" }}>'</span>s Look
//                       </h3>
//                       <p
//                         className="t2 small1"
//                         style={{
//                           fontWeight: "300",
//                           width: "100%",
//                           maxWidth: "100%",
//                         }}
//                       >
//                         At Shield Sports, we help athletes, teams, and
//                         organizations create high-performance, customized
//                         sportswear that represents their unique identity.
//                         Whether you're a professional team, a local club, or an
//                         event organizer, our cutting-edge design platform and
//                         premium-quality materials ensure that you look and
//                         perform at your best.
//                       </p>
//                       <p style={{ fontStyle: "italic" }}>
//                         Create your jersey now!
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="cms-block block-container-2 title-text-box pos-0 cms-block-text">
//             <div className="cms-block-container">
//               <div className="cms-block-container-row row cms-row">
//                 <div
//                   className="col-12"
//                   data-cms-element-id="2eb0409c0b874fceacad996d8f8bf32a"
//                 >
//                   <div className="cms-element-text">
//                     <div className="text-box-emotion">
//                       <h3 className="t1 large1">
//                         Transform Your Team
//                         <span style={{ fontFamily: "Arial" }}>'</span>s Look
//                       </h3>
//                       <p
//                         className="t2 small1"
//                         style={{
//                           fontWeight: "300",
//                           width: "100%",
//                           maxWidth: "100%",
//                         }}
//                       >
//                         At Shield Sports, we specialize in crafting
//                         high-performance, custom sportswear that reflects your
//                         team’s distinct identity. Whether you're part of a
//                         professional league, a local club, or organizing a major
//                         event, our advanced design platform and premium
//                         materials ensure your team looks sharp and performs at
//                         its best.
//                       </p>
//                       <p style={{ fontStyle: "italic" }}>
//                         Create your customized team jerseys today and stand out
//                         on the field!
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="slider-container">
//             <h2 className="slider-heading middle1">
//               SELECT YOUR SPORT, FIND YOUR GEAR, AND GET IN THE GAME!
//             </h2>
//             <Slider {...settings}>
//               {sports.map((sport, index) => (
//                 <div
//                   key={index}
//                   className="slide"
//                   onClick={() => handleSportClick(sport.name.toLowerCase())}
//                   style={{ cursor: "pointer" }}
//                 >
//                   <div
//                     className="image-container"
//                     style={{ cursor: "pointer" }}
//                   >
//                     <img
//                       src={sport.image1}
//                       alt={sport.name}
//                       className="sport-image default-image"
//                       loading="lazy"
//                     />
//                     <img
//                       src={sport.image2}
//                       alt={sport.name}
//                       className="sport-image hover-image"
//                       loading="lazy"
//                     />
//                   </div>
//                   <h3 className="sport-name">{sport.name}</h3>
//                 </div>
//               ))}
//             </Slider>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default React.memo(TakeClub);

import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../Styles/SportsSlider.css";
import {
  allProductDetails,
  homefilterApi,
} from "../../Services/Operations/ProductAPI";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

function TakeClub() {
  const [jerseys, setJerseys] = useState([]);
  const [mobile, setMobile] = useState(window.innerWidth < 567 ? true : false);
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const sports = [
    {
      name: "RUNNING",
      image1: "/asset/img/Ecom/running.webp",
      image2: "/asset/img/Ecom/4 (2).webp",
      link: "/productListing/men/men-x-jersey/men/Running/36/X%20jersey",
    },
    {
      name: "CRICKET",
      image1: "/asset/img/Ecom/cricket.webp",
      image2: "/asset/img/Ecom/34.webp",
      link: "/productListing/men/men-cricket-jersey/men/Cricket/32/Jersey",
    },
    {
      name: "FOOTBALL",
      image1: "/asset/img/Ecom/football.webp",
      image2: "/asset/img/Ecom/20.webp",
      link: "/productListing/men/men-football-jersey/men/Football/50/Jersey",
    },
    {
      name: "BADMINTON",
      image1: "/asset/img/Ecom/badminton.webp",
      image2: "/asset/img/Ecom/14 (3).webp",
      link: "/productListing/men/men-jersey/men/Badminton/22/Jersey",
    },
    {
      name: "CYCLING",
      image1: "/asset/img/Ecom/cycling.webp",
      image2: "/asset/img/Ecom/30.webp",
      link: "/productListing/men/men-cycling-jersey/men/Cycling/25/Cycling%20Jersey",
    },
    {
      name: "FITNESS",
      image1: "/asset/img/Ecom/fitness.webp",
      image2: "/asset/img/Ecom/3 (2).webp",
      link: "/productListing/men/men-basic-t-shirt/men/Fitness/40/Basic%20T%20shirt",
    },
    {
      name: "BASKETBALL",
      image1: "/asset/img/Ecom/basketball.webp",
      image2: "/asset/img/Ecom/28.webp",
      link: "/productListing/men/men-arm-sleeves/men/Basketball/47/Arm%20sleeves",
    },
  ];
 const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  initialSlide: 0,
  adaptiveHeight: false, // Change to false for better control
  swipeToSlide: true,
  draggable: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: isIOS ? 1.5 : 1.7,
        centerMode: false,
        variableWidth: false, // Change to false for better control
      }
    }
  ]
};

  const settings1 = {
    infinite: true,
    adaptiveHeight: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1030,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 870,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 715,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 380,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
    cssEase: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  };

  useEffect(() => {
    const fetchCricket = async () => {
      try {
        const products = await homefilterApi("football");
        console.log("Products for football:", products);
        setJerseys(products.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchCricket();
  }, []);

  const navigate = useNavigate();

  const handleSportClick = async (categoryName, link) => {
    try {
      console.log("categoryName : ", categoryName);
      const products = await homefilterApi(categoryName);
      console.log("Products for:", categoryName, products);

      // navigate("/AllListingPage", {
      //   state: {
      //     products: products.data,
      //   },
      // });
      navigate(link);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const handleProductClick = (jersey, slug) => {
    console.log("jersey : ", jersey);
    navigate(`/detailsPage/${slug}`);
  };

  const tickets = [
    { image: "/asset/img/12.png" },
    { image: "/asset/img/10.png" },
    { image: "/asset/img/7.png" },
    { image: "/asset/img/12.png" },
    { image: "/asset/img/10.png" },
    { image: "/asset/img/7.png" },
  ];

  return (
    <div>
      <div className="slider-container" style={{ backgroundColor: "white" }}>
        <p
          style={{
            fontSize: window.innerWidth > 656 ? "48px" : "16px",
            marginBottom: mobile ? -1 : "0.5rem",
            color: "black",
            fontWeight: mobile ? 900 : 500,
            padding: mobile ? "16px" : "20px",
            paddingTop: "30px",
            width: mobile ? "100%" : "60%",
            textAlign: mobile ? "center" : "left",
            fontFamily: "Poppins ,sans-serif",
          }}
        >
          SELECT YOUR SPORT, FIND YOUR GEAR, AND GET IN THE GAME!
        </p>

  <motion.div
  initial={{ y: 80, opacity: 0 }}
  whileInView={{ y: 0, opacity: 1 }}
  transition={{ duration: 1.4, ease: "easeOut" }}
  style={{ borderRadius: "16px" }}
>
  <Slider {...settings}>
    {sports.map((sport, index) => (
      <motion.div
        key={index}
        className="slide"
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          console.log("Clicked sport:", sport.name);
          console.log("Expected link:", sport.link);
          navigate(sport.link);
        }}
      >
        <div
          style={{
            cursor: "pointer",
            padding: "10px",
            borderRadius: "16px",
            borderBottom: "3px solid gray",
            borderRight: "2px solid gray",
            borderLeft: "2px solid gray",
          }}
        >
          <img
            src={sport.image1}
            alt={sport.name}
            className="sport-image default-image"
            loading="lazy"
          
          />
          {/* <img
            src={sport.image2}
            alt={sport.name}
            className="sport-image hover-image"
            loading="lazy"
           
          /> */}
        </div>
      </motion.div>
    ))}
  </Slider>
</motion.div>
      </div>

      <div
        className="cms-section no-overflow pos-3 cms-section-default"
        style={{ backgroundColor: "white" }}
      >
        <div className="cms-section-default full-width">
          <style jsx>{`
            /* Base Styles */
            .shield-container {
              color: #333;
              padding: 0;
              margin: 0;
            }
            .discount-size {
              font-size: 14px;
            }

            .shield-block {
              max-width: 100%;
              backdrop-filter: blur(10px);
              border-radius: 20px;
              margin: 0px;
              padding: 0px 30px;
              transform: translateY(50px);
              opacity: 0;
              animation: slideInUp 0.8s ease-out forwards;
              position: relative;
              overflow: hidden;
            }

            .shield-block::before {
              content: "";
              position: absolute;
              top: 0;
              left: -100%;
              width: 100%;
              height: 100%;
              animation: shimmer 3s infinite;
            }

            .title-text-box .t2 {
              max-width: max-content;
            }

            .shield-block:nth-child(2) {
              animation-delay: 0.3s;
            }

            .shield-block-container {
              position: relative;
              z-index: 2;
            }

            .shield-text-box {
              text-align: center;
              position: relative;
            }

            .shield-title {
              color: black;
              font-size: 2rem;
              font-weight: 500;
              background-size: 200% 200%;
              -webkit-background-clip: text;
              text-align: left;
              background-clip: text;
              animation: gradientShift 3s ease-in-out infinite;
              margin-bottom: 20px;
              position: relative;
            }

            .shield-title::after {
              content: "";
              position: absolute;
              bottom: -10px;
              left: 50%;
              transform: translateX(-50%);
              width: 80px;
              height: 4px;
              border-radius: 2px;
              animation: expandWidth 1s ease-out 0.5s forwards;
              width: 0;
            }

            .shield-description {
              text-align: left;
              font-size: 1.1rem;
              color: black;
              margin-bottom: 20px;
              animation: fadeInUp 0.8s ease-out 0.4s forwards;
              opacity: 0;
              transform: translateY(20px);
              font-weight: 300;
              width: 100%;
              max-width: 100%;
            }

            .shield-cta {
              font-size: 1.2rem;
              color: #667eea;
              font-weight: 600;
              animation: pulse 2s ease-in-out infinite;
              position: relative;
              display: inline-block;
              font-style: italic;
            }

            .shield-cta::before {
              content: "✨";
              margin-right: 10px;
              animation: rotate 2s linear infinite;
            }

            .shield-cta::after {
              content: "✨";
              margin-left: 10px;
              animation: rotate 2s linear infinite reverse;
            }

            .shield-apostrophe {
            }

            .shield-row {
              animation: contentLoad 0.6s ease-out 0.6s forwards;
              opacity: 0;
            }

            .shield-col {
              width: 100%;
            }

            /* Hover Effects */
            .shield-block:hover {
              transform: translateY(-5px);
              transition: all 0.3s ease;
            }

            .shield-block:hover .shield-title {
              transform: scale(1.05);
              transition: transform 0.3s ease;
            }

            /* Animations */
            @keyframes slideInUp {
              to {
                transform: translateY(0);
                opacity: 1;
              }
            }

            @keyframes fadeInUp {
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }

            @keyframes gradientShift {
              0%,
              100% {
                background-position: 0% 50%;
              }
              50% {
                background-position: 100% 50%;
              }
            }

            @keyframes shimmer {
              0% {
                left: -100%;
              }
              100% {
                left: 100%;
              }
            }

            @keyframes expandWidth {
              to {
                width: 80px;
              }
            }

            @keyframes pulse {
              0%,
              100% {
                transform: scale(1);
              }
              50% {
                transform: scale(1.05);
              }
            }

            @keyframes rotate {
              from {
                transform: rotate(0deg);
              }
              to {
                transform: rotate(360deg);
              }
            }

            @keyframes contentLoad {
              to {
                opacity: 1;
              }
            }

            /* Mobile Media Queries */
            @media screen and (max-width: 768px) {
              .shield-block-mobile {
                margin: 15px 10px;
                padding: 25px 20px;
                border-radius: 16px;
              }

              .shield-title-mobile {
                font-size: 2rem;
                margin-bottom: 16px;
              }

              .shield-title-mobile::after {
                width: 60px;
                bottom: -8px;
              }

              .shield-description-mobile {
                font-size: 1rem;
                margin-bottom: 16px;
                padding: 0 10px;
              }

              .shield-cta-mobile {
                font-size: 1.1rem;
              }

              .shield-text-box-mobile {
                padding: 0 5px;
              }

              .shield-block:hover {
                transform: translateY(-3px);
              }
            }

            @media screen and (max-width: 480px) {
              .shield-container-small {
              }

              .shield-block-small {
                margin: 12px 8px;
                padding: 20px 16px;
                border-radius: 12px;
              }

              .shield-title-small {
                font-size: 1.8rem;
                margin-bottom: 14px;
              }

              .shield-title-small::after {
                width: 50px;
                height: 3px;
                bottom: -6px;
              }

              .shield-description-small {
                font-size: 0.95rem;
                margin-bottom: 14px;
              }

              .shield-cta-small {
                font-size: 1rem;
              }

              .shield-cta-small::before,
              .shield-cta-small::after {
                font-size: 0.8rem;
              }
              .discount-size {
                font-size: 10px;
              }
              .discount-badge {
                font-size: 0.5rem;
              }
              .shield-cta-xs {
                font-size: 11px;
              }
            }
              /* SportsSlider.css */
.slick-slider {
  position: relative;
  display: block;
  box-sizing: border-box;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -khtml-user-select: none;
  -ms-touch-action: pan-y;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
}

.slick-list {
  position: relative;
  display: block;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

.slick-track {
  position: relative;
  top: 0;
  left: 0;
  display: flex;
  margin-left: auto;
  margin-right: auto;
}

.slick-slide {
  float: left;
  height: 100%;
  min-height: 1px;
  padding: 0 10px;
}

/* Fix for slide movement */
.slide {
  position: relative;
  margin: 0 5px;
}

.sport-image {
  width: 100%;
  height: auto;
  display: block;
  transition: opacity 0.3s ease;
}

.default-image {
  opacity: 1;
  position: relative;
}




            @media screen and (max-width: 360px) {
              .shield-block-xs {
                margin: 10px 6px;
                padding: 18px 14px;
              }

              .shield-title-xs {
                font-size: 1.6rem;
                margin-bottom: 12px;
              }

              .shield-description-xs {
                font-size: 0.9rem;
                margin-bottom: 12px;
              }

              .shield-cta-xs {
                font-size: 11px;
              }
            }
          `}</style>

          <div className="shield-container shield-container-small">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "space-around",
                borderTopLeftRadius: "10px",
                borderBottomLeftRadius: "10px",
                marginTop: mobile ? 0 : "25px",
                borderTop: "8px solid black",
                borderBottom: "8px solid black",
                marginLeft: "",
                backgroundColor: "black",
              }}
            >
              <div
                style={{
                  color: "white",
                  backgroundColor: "black",
                  width: "150px",
                  height: "100%",
                  marginLeft: "18px",
                  paddingRight: "1px",
                  paddingLeft: "4px",
                  fontSize: mobile ? "12px" : "20px",
                  fontWeight: 600,
                  borderLeft: "4px solid yellow",
                }}
              >
                SPECIAL COUPON CORNER
              </div>

              <div
                style={{
                  width: "100%",
                  overflow: "hidden",
                  padding: "4px",
                  backgroundColor: "white",
                  borderTopLeftRadius: "10px",
                  borderBottomLeftRadius: "10px",
                }}
              >
                <Slider
                  {...settings1}
                  className=""
                  style={{
                    backgroundColor: "white",
                    width: "180%",
                    gap: "10px",
                  }}
                >
                  {tickets.map((ticket, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadious: "10px",
                      }}
                    >
                      <img
                        src={ticket.image}
                        style={{
                          width: "98%",
                          marginTop: "5px",
                          borderRadious: "10px",
                        }}
                      />
                    </div>
                  ))}
                </Slider>
              </div>
            </div>

            <div
              style={{
                backgroundColor: "white",
                padding: "10px 20px",
                paddingLeft: "20px",
                paddingRight: "20px",
                paddingTop: mobile ? "10px" : "25px",
              }}
            >
              <div
                style={{
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                <p
                  style={{
                    fontSize: mobile ? "20px" : "48px",
                    color: "black",
                    fontWeight: mobile ? 600 : 500,
                    fontStyle: "Poppins",
                    padding: "5px",
                    textAlign: mobile ? "center" : "center",
                  }}
                >
                  <span>Latest Football Jersey</span>
                  <br />
                  {window.innerWidth < 567 && (
                    <span
                      style={{
                        fontFamily: "Poppins",
                        color: "gray",
                        fontSize: "12px",
                        textAlign: "center",
                        fontWeight: "normal",
                      }}
                    >
                      Book your Football team jersey
                    </span>
                  )}
                </p>

                {!mobile && (
                  <Slider
                    {...settings1}
                    className=""
                    style={{ backgroundColor: "white" }}
                  >
                    {jerseys?.map((jersey) => {
                      const discount =
                        jersey.size && jersey.size.length > 0
                          ? jersey.size[0].discount_percent
                          : 0;
                      const price =
                        jersey.size && jersey.size.length > 0
                          ? jersey.size[0].price
                          : 0;
                      const mrp =
                        jersey.size && jersey.size.length > 0
                          ? jersey.size[0].mrp
                          : 0;

                      function limitTextToWords(text, wordLimit) {
                        if (typeof text !== "string") return "";
                        const words = text.trim().split(/\s+/); // split by whitespace
                        if (words.length <= wordLimit) return text;
                        return words.slice(0, wordLimit).join(" ") + "...";
                      }

                      return (
                        <div
                          key={jersey.id}
                          style={{
                            padding: "0 8px",
                            background:
                              "linear-gradient(white, rgba(255, 255, 255, 1))",
                          }}
                        >
                          <div
                            style={{
                              backgroundColor: "#ffffff",
                              borderRadius: "10px",
                              overflow: "hidden",
                              transition: "all 0.3s ease",
                              transform: "translateY(0)",

                              position: "relative",
                              // width: "334px",
                            }}
                            className="jersey-card"
                          >
                            <div
                              style={{
                                position: "relative",
                                overflow: "hidden",
                                height: "235px",
                                // width: "320px",
                              }}
                            >
                              <img
                                src={jersey.image}
                                alt={jersey.name}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "contain",
                                  transition: "transform 0.5s ease",
                                  borderRadius: "0px",
                                }}
                                className="jersey-image"
                              />
                              <img
                                style={{
                                  position: "absolute",
                                  top: 5,
                                  right: 5,
                                  width: "25px",
                                }}
                                src="/asset/img/heart.png"
                              />
                              <p
                                style={{
                                  position: "absolute",
                                  zIndex: 99999,
                                  borderRadius: "5px",
                                  top: 0,
                                  left: 0,
                                  fontSize: "10px",
                                  padding: "5px",
                                  background:
                                    "linear-gradient(to right, #ee1e03ff, #e7a109ff)",
                                  color: "white",
                                }}
                              >
                                New Arrival
                              </p>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                // height: "150px",
                              }}
                            >
                              <div
                                style={{
                                  padding: "3px",
                                  paddingLeft: "10px",
                                  paddingRight: "10px",
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: 700,
                                    fontStyle: "bold",

                                    marginBottom: "4px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    fontFamily: "inherit",
                                    textOverflow: "ellipsis",
                                    color: "black",
                                  }}
                                >
                                  {jersey.name}
                                </p>
                                <p
                                  style={{
                                    marginBottom: "0.4rem",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    color: "gray",
                                  }}
                                >
                                  {limitTextToWords(jersey.name, 10)}
                                </p>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    marginBottom: "4px",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: "20px",
                                      fontWeight: 700,
                                      fontStyle: "bold",
                                      color: "black",
                                      fontFamily: "ITF Devanagari",
                                    }}
                                  >
                                    ${price}
                                  </span>
                                  <span
                                    style={{
                                      fontSize: "15px",
                                      color: "#686767ff",
                                      textDecoration: "line-through",
                                      fontFamily: "ITF Devanagari",
                                    }}
                                  >
                                    ${mrp}
                                  </span>
                                  <span
                                    style={{
                                      width: "51px",
                                      height: "17px",
                                      borderRadius: "20px",
                                      backgroundColor: "#F1A3A3",
                                      color: "#CE0505",
                                      fontSize: "11px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {"-"}{" "}
                                    {Math.round(((mrp - price) / mrp) * 100)}%
                                  </span>
                                </div>
                              </div>
                              <p
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleProductClick(jersey, jersey.slug);
                                }}
                                style={{
                                  marginLeft: "9px",
                                  cursor: "pointer",
                                  borderBottom: "1.5px solid black",
                                  width: "fit-content",
                                  fontSize: "15px",
                                  fontWeight: "bold",
                                }}
                              >
                                Shop Now
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                )}

                {mobile && (
                  <Slider
                    {...settings1}
                    className="jersey-slider"
                    style={{ backgroundColor: "white" }}
                  >
                    {jerseys.map((jersey) => {
                      const discount =
                        jersey.size && jersey.size.length > 0
                          ? jersey.size[0].discount_percent
                          : 0;
                      const price =
                        jersey.size && jersey.size.length > 0
                          ? jersey.size[0].price
                          : 0;
                      const mrp =
                        jersey.size && jersey.size.length > 0
                          ? jersey.size[0].mrp
                          : 0;

                      function limitTextToWords(text, wordLimit) {
                        if (typeof text !== "string") return "";
                        const words = text.trim().split(/\s+/); // split by whitespace
                        if (words.length <= wordLimit) return text;
                        return words.slice(0, wordLimit).join(" ") + "...";
                      }

                      return (
                        <div
                          key={jersey.id}
                          style={{
                            padding: "0 8px",
                            background:
                              "linear-gradient(white, rgb(255, 230, 255))",
                          }}
                        >
                          <div
                            style={{
                              backgroundColor: "#ffffff",
                              borderRadius: "8px",
                              overflow: "hidden",
                              width: "330",

                              transition: "all 0.3s ease",
                              transform: "translateY(0)",

                              position: "relative",
                            }}
                            className="jersey-card"
                          >
                            <div
                              style={{
                                position: "relative",
                                overflow: "hidden",
                                height: "180px",
                                width: "240",
                              }}
                            >
                              <img
                                src={jersey.image}
                                alt={jersey.name}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "contain",
                                  transition: "transform 0.5s ease",
                                  borderRadius: "0px",
                                }}
                                className="jersey-image"
                              />
                              <img
                                style={{
                                  position: "absolute",
                                  top: 5,
                                  right: 5,
                                  width: "25px",
                                }}
                                src="/asset/img/heart.png"
                              />
                              <p
                                style={{
                                  position: "absolute",
                                  borderRadius: "5px",
                                  top: 0,
                                  left: 0,
                                  fontSize: "10px",
                                  padding: "5px",
                                  background:
                                    "linear-gradient(to right, #ee1e03ff, #e7a109ff)",
                                  color: "white",
                                }}
                              >
                                New Arrival
                              </p>
                            </div>

                            <div style={{}}>
                              <p
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 700,
                                  fontStyle: "bold",
                                  color: "#000000ff",
                                  marginBottom: "4px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleProductClick(jersey, jersey.slug);
                                }}
                              >
                                {jersey.name}
                              </p>
                              <p
                                style={{
                                  fontSize: "8px",
                                  fontWeight: "bold",
                                  color: "gray",
                                }}
                              >
                                {limitTextToWords(jersey.name, 8)}
                              </p>

                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  marginBottom: "4px",
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: 700,
                                    fontStyle: "bold",
                                    color: "black",
                                    fontFamily: "ITF Devanagari",
                                  }}
                                >
                                  ${price}
                                </span>
                                <span
                                  style={{
                                    fontSize: "10px",
                                    color: "#504f50ff",
                                    fontWeight: 700,
                                    fontStyle: "bold",
                                    textDecoration: "line-through",
                                    fontFamily: "ITF Devanagari",
                                  }}
                                >
                                  ${mrp}
                                </span>
                                <span
                                  style={{
                                    width: "25px",
                                    height: "10px",
                                    borderRadius: "20px",
                                    textAlign: "center",
                                    fontSize: "7px",
                                    color: "#CE0505",
                                    backgroundColor: "#F1A3A3",
                                  }}
                                >
                                  {"-"}
                                  {Math.round(((mrp - price) / mrp) * 100)}%
                                </span>
                              </div>
                              <p
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleProductClick(jersey, jersey.slug);
                                }}
                                style={{
                                  cursor: "pointer",
                                  borderBottom: "1.5px solid black",
                                  width: "fit-content",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                }}
                              >
                                Shop Now
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                )}
              </div>

              <style jsx global>{`
                .jersey-slider .slick-prev:before,
                .jersey-slider .slick-next:before {
                  color: #4f46e5;
                  font-size: 24px;
                }
                .slick-list {
                  background-color: white;
                }

                .jersey-slider .slick-dots li button:before {
                  font-size: 12px;
                  color: #4f46e5;
                }

                .jersey-slider .slick-dots li.slick-active button:before {
                  color: #4f46e5;
                  opacity: 1;
                }

                .jersey-slider .slick-slide {
                  padding: 0 10px;
                }

                .jersey-card:hover {
                  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
                    0 10px 10px -5px rgba(0, 0, 0, 0.04);
                  transform: translateY(-4px);
                }

                .jersey-image:hover {
                  transform: scale(1.05);
                }
              `}</style>
            </div>
            {/* <div className="shield-block shield-block-mobile shield-block-small shield-block-xs cms-block block-container-2 title-text-box pos-0 cms-block-text">
              <div className="shield-block-container cms-block-container">
                <div className="shield-row cms-block-container-row row cms-row">
                  <div
                    className="shield-col col-12"
                    data-cms-element-id="2eb0409c0b874fceacad996d8f8bf32a"
                  >
                    <div className="cms-element-text">
                      <div className="shield-text-box shield-text-box-mobile text-box-emotion">
                        <h3 className="shield-title shield-title-mobile shield-title-small shield-title-xs t1 large1">
                          Transform Your Team
                          <span className="shield-apostrophe">'</span>s Look
                        </h3>
                        <p
                          style={{ textAlign: "justify" }}
                          className="shield-description shield-description-mobile shield-description-small shield-description-xs t2 small1"
                        >
                          At Shield Sports, we specialize in crafting
                          high-performance, custom sportswear that reflects your
                          team's distinct identity. Whether you're part of a
                          professional league, a local club, or organizing a
                          major event, our advanced design platform and premium
                          materials ensure your team looks sharp and performs at
                          its best.
                        </p>
                        <p
                          style={{ textAlign: "justify" }}
                          className="shield-cta shield-cta-mobile shield-cta-small shield-cta-xs"
                        >
                          Create your customized team jerseys today and stand
                          out on the field!
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(TakeClub);
